import { Controller } from "@hotwired/stimulus"
import { createAlert } from "../scripts/createAlert"

export default class extends Controller {
  validate(event) {
    let valid = true

    this.element.querySelectorAll('select[name*="[nomination_type]"]').forEach((select) => {
      select.classList.remove("is-invalid")
    })

    this.element.querySelectorAll('input[type="checkbox"][name*="[checked]"]:checked').forEach((checkbox) => {
      const playerId = checkbox.name.match(/nomination_players\[([^\]]+)\]/)?.[1]
      if (!playerId) return

      const select = this.element.querySelector(`select[name="nomination_players[${playerId}][nomination_type]"]`)
      if (select && !select.value) {
        select.classList.add("is-invalid")
        valid = false
      }
    })

    if (!valid) {
      event.preventDefault()
      createAlert("danger", "Please select a nomination type for each selected player.")
      this.element.querySelector("select.is-invalid")?.scrollIntoView({ block: "nearest" })
    }
  }

  clearInvalid(event) {
    if (event.target.matches('select[name*="[nomination_type]"]') && event.target.value) {
      event.target.classList.remove("is-invalid")
    }

    if (event.target.matches('input[type="checkbox"][name*="[checked]"]') && !event.target.checked) {
      const playerId = event.target.name.match(/nomination_players\[([^\]]+)\]/)?.[1]
      if (!playerId) return

      const select = this.element.querySelector(`select[name="nomination_players[${playerId}][nomination_type]"]`)
      select?.classList.remove("is-invalid")
    }
  }
}
